import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["counter"]
const _hoisted_2 = { class: "filter-dropdown__header" }

import PlusSvg from '@/assets/plus.svg';
import TimesSvg from '@/assets/times.svg';
import FilterSvg from '@/assets/filter.svg';

// Components
import VPopper from 'vue3-popper';
import VButton from './VButton.vue';
import VButtonDropdown from './VButtonDropdown.vue';
import VGridRow from './VGridRow.vue';
import VGridColumn from './VGridColumn.vue';
import VGridContainer from './VGridContainer.vue';

// Other
import { useI18n } from 'vue-i18n';
import { computed, PropType, ref, watch } from 'vue';
import { IDropdownOption } from '@/core/Values/IDropdownOption';
import { IFilterPopupContext, IFilterPopupOption, InitFilterPopupOption } from '@/core/Values/IFilterPopup';


export default /*@__PURE__*/_defineComponent({
  __name: 'VFilterPopup',
  props: {
    options: { type: Object as PropType<InitFilterPopupOption[]>, required: true },
    modelValue: { type: Object, required: true },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

// Svg
const { t } = useI18n();
const emit = __emit;
const props = __props;

let options = ref<IDropdownOption[]>([]);
let filters = ref<IFilterPopupOption[]>([]);
let checkboxFilters = ref<IFilterPopupOption[]>([]);
let context: IFilterPopupContext = {
    t,
    value: {},
    submit,
    addFilter,
    removeFilter,
    addOption,
    removeOption,
};

const filtersCount = computed(() => Object.values(props.modelValue).filter((value) => value).length);

watch(() => props.options, initFilters);
watch(() => props.modelValue, initFilters, { immediate: true });

function clear() {
    emit('update:modelValue', {}); // Should call initFilters thought watcher.
}

function submit(filter: Record<string, unknown>): void {
    context.value = { ...props.modelValue, ...filter };
    emit('update:modelValue', context.value);
}

function addFilter(filter: IFilterPopupOption): void {
    if (filter.isCheckbox) {
        if (!checkboxFilters.value.includes(filter)) {
            checkboxFilters.value.push(filter);
        }
        return;
    }

    const index = filters.value.indexOf(filter);

    if (index === -1) {
        filters.value.push(filter);
    }
}

function removeFilter(filter: IFilterPopupOption): void {
    const index = filters.value.indexOf(filter);

    if (index !== -1) {
        filters.value.splice(index, 1);
    }
}

function addOption(option: IDropdownOption): void {
    const potentialCheckbox = option as IFilterPopupOption;

    if (potentialCheckbox.isCheckbox) {
        if (!checkboxFilters.value.includes(potentialCheckbox)) {
            checkboxFilters.value.push(potentialCheckbox);
        }
        return;
    }

    const index = options.value.indexOf(option);

    if (index === -1) {
        options.value.push(option);
    }
}

function removeOption(option: IDropdownOption): void {
    const index = options.value.indexOf(option);

    if (index !== -1) {
        options.value.splice(index, 1);
    }
}

function initFilters() {
    if (props.modelValue === context.value) {
        return;
    }

    context.value = structuredClone(props.modelValue);
    options.value = [];
    filters.value = [];
    checkboxFilters.value = [];
    props.options.forEach((option) => option(context));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VPopper), _mergeProps({
    class: "task-filter",
    "offset-distance": "6",
    placement: "bottom-start",
    "z-index": "10000"
  }, _ctx.$attrs), {
    content: _withCtx(({ close }) => [
      _createVNode(VGridContainer, { class: "filter-dropdown" }, {
        default: _withCtx(() => [
          _createVNode(VGridRow, { class: "grid--space-between" }, {
            default: _withCtx(() => [
              _createVNode(VGridColumn, { class: "grid--center" }, {
                default: _withCtx(() => [
                  _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(t)('filters')), 1)
                ]),
                _: 1
              }),
              _createVNode(VGridColumn, null, {
                default: _withCtx(() => [
                  _createVNode(VGridRow, null, {
                    default: _withCtx(() => [
                      _createVNode(VButton, {
                        class: "button--link button--vcenter button--margin-right",
                        onClick: clear
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('clear')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(VButton, {
                        class: "button--rounded button--transparent button--vcenter button--margin-left",
                        onClick: close
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(TimesSvg))
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024),
          _createVNode(VGridRow, null, {
            default: _withCtx(() => [
              _createVNode(VGridContainer, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filters), (filter, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      _createVNode(VGridRow, { class: "grid--padding-top-100" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(filter.title) + ": ", 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(VGridRow, { class: "grid--padding-top-25" }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(filter.component), _mergeProps(_toHandlers(filter.on), { ref_for: true }, filter.attrs), null, 16))
                        ]),
                        _: 2
                      }, 1024)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkboxFilters), (filter, index) => {
            return (_openBlock(), _createBlock(VGridRow, {
              key: `chk-${index}`,
              class: "grid--padding-top-100"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(filter.component), _mergeProps(_toHandlers(filter.on), { ref_for: true }, filter.attrs), null, 16))
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _withDirectives(_createVNode(VGridRow, { class: "grid--padding-top-100" }, {
            default: _withCtx(() => [
              _createVNode(VButtonDropdown, {
                options: _unref(options),
                placement: "bottom-start"
              }, {
                button: _withCtx(() => [
                  _createVNode(VButton, { class: "button--secondary button--transparent" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(PlusSvg)),
                      _createTextVNode(" " + _toDisplayString(_unref(t)('add-filter')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["options"])
            ]),
            _: 1
          }, 512), [
            [_vShow, _unref(options).length]
          ])
        ]),
        _: 2
      }, 1024)
    ]),
    default: _withCtx(() => [
      _createVNode(VButton, {
        class: _normalizeClass(["button--secondary button--default button--center button--vcenter task-filter__control", { 'task-filter__control--active': filtersCount.value > 0 }])
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FilterSvg)),
          _createElementVNode("span", { counter: filtersCount.value }, _toDisplayString(_unref(t)('filter')), 9, _hoisted_1)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }, 16))
}
}

})